import React, { useState, setState } from 'react';
import PropTypes from 'prop-types';
import { 
  Grid,
  makeStyles 

} from '@material-ui/core';
import NavBar from './NavBar';
import TopBar from './TopBar/index';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.light,
    display: 'flex',
    flexDirection:'row',
    height: '100%',
    overflow: 'auto',
    width: '100%'
  },
  mainContent: {
    // width: 'calc( "100% - 256px" )',
    // width: '100%',
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'auto',
    // paddingTop: 64,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256
    }
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'auto'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto'
  }
}));

const DashboardLayout = ({ children }) => {
  const classes = useStyles();
  const [state, setState] = React.useState({
    isMobileNavOpen: false,
    selectedMenu: "대시보드"
  });
  

  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item className={classes.nav}>
        <div>
          <NavBar
            onMobileClose={() => setState({
              ...state,
              isMobileNavOpen: false,
            })}
            openMobile={state.isMobileNavOpen}
            changeMenu={(title) => setState({
              ...state,
              selectedMenu: title
            })} 
          /> 
        </div>
        </Grid>
        <Grid item xs={12}>
        <div className={classes.wrapper}>
          <div className={classes.contentContainer}>

            <div className={classes.content}>
              <TopBar 
                onMobileNavOpen={() => setState({
                  ...state,
                  isMobileNavOpen: true,
                })}
                onToggleDrawer={() => setState({
                  ...state,
                  isMobileNavOpen: !state.isMobileNavOpen,
                })}
                selectedmenu={state.selectedMenu}
              />
              {children}
            </div>
          </div>
        </div>
        </Grid> 
      </Grid>
    </div>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node
};

export default DashboardLayout;
